import { render, staticRenderFns } from "./search-results-item.vue?vue&type=template&id=85ab51fc"
import script from "./search-results-item.vue?vue&type=script&lang=js"
export * from "./search-results-item.vue?vue&type=script&lang=js"
import style0 from "./search-results-item.vue?vue&type=style&index=0&id=85ab51fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports